const strings = {
  TITLE: 'Titel',
  TITLE_ENGLISH: 'Titel (engelska)',
  INFORMATION: 'Information',
  INFORMATION_ENGLISH: 'Information (engelska)',
  INFORMATION_TYPE: 'Informationstyp',
  CANCEL: 'Avbryt',
  DELETE_LAUNDRY_TIME: 'Ta bort tvättid',
  DELETE_LAUNDRY_TIME_INFO:
    'Är du säker på att du vill ta bort tvättiden? Detta kan inte göras ogjort.',
  YES: 'Ja',
  NO: 'Nej',
  MANAGE_INFORMATION: 'Hantera informationstavla',
  NEW_INFORMATION: 'Ny information',
  DELETE_INFORMATION: 'Ta bort information',
  DELETE_INFORMATION_INFO:
    'Är du säker på att du vill ta bort informationen? Detta kan inte göras ogjort.',
  TYPE: {
    phone: 'Telefonnummer',
    email: 'Emailadress',
    url: 'Hemsida',
    text: 'Informativ text'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/InformationTable/strings.js